/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsUtilizationAzureAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsUtilizationAzureAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsUtilizationAzureAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsUtilizationAzureAdvisorResource>): RecommendationForFinopsUtilizationAzureAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsUtilizationAzureAdvisorResource(), model);
        RecommendationForFinopsUtilizationAzureAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsUtilizationAzureAdvisorResource>): RecommendationForFinopsUtilizationAzureAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsUtilizationAzureAdvisorResource.newInstance(<RecommendationForFinopsUtilizationAzureAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsUtilizationAzureAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsUtilizationAzureAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsUtilizationAzureAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsUtilizationAzureAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
